import { createFileRoute } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import React from 'react'
import z from 'zod'
import { RtlsFileExport, RtlsFileImport, RtlsPlus } from '@/icons'
import { Button } from '@/components/ui/button'
import PageContainer from '@/components/page-container'

export const customerStatusFilterOptions = ['Active', 'Inactive'] as const

export type CustomerStatus = (typeof customerStatusFilterOptions)[number]

export const orderListSearchSchema = z.object({
  page: fallback(z.string().optional(), '1'),
  limit: fallback(z.string().optional(), '10'),
  keyword: fallback(z.string().optional(), ''),
  status: fallback(z.enum([...customerStatusFilterOptions, '']).optional(), ''),
})

export const Route = createFileRoute('/admin/management/customers')({
  component: ManagementCustomers,
  validateSearch: zodValidator({
    schema: orderListSearchSchema,
    input: 'input',
    output: 'output',
  }),
  staticData: {
    breadcrumb: 'Customers',
  },
})

function ManagementCustomers() {
  const actions = React.useMemo(
    () => [
      <Button key="import" variant="outline" className="w-full sm:w-auto">
        <RtlsFileImport />
        Import Data
      </Button>,
      <Button key="export" variant="outline" className="w-full sm:w-auto">
        <RtlsFileExport />
        Export Data
      </Button>,
      <Button key="create" className="w-full sm:w-auto">
        <RtlsPlus /> Add New Customer
      </Button>,
    ],
    [],
  )
  return (
    <PageContainer title="Customers" actions={actions}>
      Hello "/admin/management/customers"!
    </PageContainer>
  )
}
